export default __webpack_public_path__ + "static/media/4.63cff867.png";